module.exports = __webpack_public_path__ + "static/3-aea61f2f7a4d4984b13cc76beac671ca.png";